module.exports = __webpack_public_path__ + "static/media/products_mb.f0a99bec.png";